import { Row } from 'react-flexbox-grid'
import styled from 'styled-components'

import { StyledColItem } from 'components/SectionHandler'

export const StyledRow = styled(Row)`
	${StyledColItem} {
		max-width: ${() => `calc(100% - 470px)`};
	}
`
export const StyledParagraph = styled.p`
	font-size: 16px;
	font-weight: 500;
`
